import dreamComponentsStylesheetHref from '@shared/dream-components/style.css?url';

import tailwindStylesheetHref from '~/tailwind.css?url';

export const SHARED_STYLESHEET_HREFS = [dreamComponentsStylesheetHref, tailwindStylesheetHref];
